import React, { useEffect, useRef, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./styles.css";

const ReactQuillEditor = (props) => {
    const reactQuillRef = useRef();
    const [disabledClass, setDisabledClass] = useState('');

    const formats = [
        "header",
        "font",
        "size",
        "bold",
        "italic",
        "underline",
        "strike",
        "blockquote",
        "list",
        "bullet",
        "indent",
        "image",
        "video",
    ];

    const modules = {
        clipboard: {
            matchVisual: false,
        },
        toolbar: [
            [{ header: "1" }, { header: "2" }, { font: [] }],
            [{ size: [] }],
            ["bold", "italic", "underline", "strike", "blockquote"],
            [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
            ["clean"],
        ],
    };

    const handleChange = (e) => {
        props.setTextData(e);
    };

    useEffect(() => {
        const editorClass = props.readOnly ? 'ql-disabled' : ''; // Use 'ql-disabled'
        setDisabledClass(editorClass);
    }, [props.readOnly]); 

    return (
        <div className="flexCol">
            <div className={`epMainForm ${disabledClass}`}>
                <ReactQuill
                    readOnly={props?.readOnly}
                    name={props?.name}
                    theme="snow"
                    modules={modules}
                    formats={formats}
                    ref={reactQuillRef}
                    placeholder={props?.placeholder}
                    value={props?.textData}
                    onChange={handleChange}
                    className={`textEditor textQuill ${disabledClass}`}
                />
            </div>
        </div>
    );
};

export default ReactQuillEditor;
